import React from 'react';
import { useSelector } from 'react-redux';
import { GetColor } from '../../utils';
import { icons } from '../../assets';
import * as s from './styled-overview';

const Overview = ({ quantidade, status, nome, type }) => {
  const { clienteSelecionado } = useSelector((state) => state.segundoNivel);
  const { user } = useSelector((state) => state.usuario);

  const name = nome
    ? nome
    : user?.customer
    ? user?.customer?.name
    : clienteSelecionado?.name;

  // `type` opcional: quando passado (ex.: na tela de aplicacao), o card
  // ganha o accent color do tipo (orange para ucha, blue para eba) e os
  // textos invertem para branco.
  const accentType = type === 'ucha' || type === 'eba' ? type : null;

  return (
    <s.Container className="style-container-aplicacao" accent={accentType}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <img src={icons.ClientPin} alt="" />
        <s.ParqueLabel accent={accentType}>{name}</s.ParqueLabel>
      </div>
      <div>
        {status && (
          <s.StatusGroup title={status}>
            <s.StatusDot color={GetColor(status)} aria-label={`Status: ${status}`} />
            <s.StatusLabel accent={accentType}>{status}</s.StatusLabel>
          </s.StatusGroup>
        )}
        {status === 'erro' && <s.Tag>{quantidade}</s.Tag>}
      </div>
    </s.Container>
  );
};

export default Overview;
